export default "dist/images/components-columns-width-control-2-1-uneven.11f93e4.png";